module.exports = __webpack_public_path__ + "img/arrowUp.d5909d37.png";